"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTransformKeyFrame = createTransformKeyFrame;
const theme_1 = require("../theme");
function createTransformKeyFrame(name, transformFrom, transformTo) {
    (0, theme_1.addStyles)({
        [`@keyframes ${name}`]: { from: { transform: transformFrom }, to: { transform: transformTo } },
    });
}
//# sourceMappingURL=transform.js.map